import React, { useCallback, useRef, useEffect, forwardRef } from "react";
import PropTypes from "prop-types";

export const FilePreviewWrapper = forwardRef(({ style, children, onKeyDown, className }, ref) => {
  const internalRef = useRef(null);

  useEffect(() => {
    internalRef.current.focus();
  }, []);

  const setRef = useCallback(
    (current) => {
      if (typeof ref === "function") {
        ref(current);
      } else if (ref) {
        ref.current = current;
      }
      internalRef.current = current;
    },
    [ref]
  );

  return (
    <div
      ref={setRef}
      style={style}
      className={className}
      onKeyDown={onKeyDown}
      tabIndex={0}
    >
      {children}
    </div>
  );
});

FilePreviewWrapper.propTypes = {
  onKeyDown: PropTypes.func,
  className: PropTypes.string,
  style: PropTypes.object,
  children: PropTypes.node,
};

FilePreviewWrapper.displayName = "FilePreviewWrapper";
